/** api.ts — cliente da API do sistema Toca (customizador + checkout). */
import type { ShirtSize } from '@toca/core';

const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? '';

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(BASE + path);
  if (!res.ok) throw new Error(`GET ${path} falhou (${res.status})`);
  return (await res.json()) as T;
}
async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(BASE + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new Error((data as { error?: string }).error || `POST ${path} falhou (${res.status})`);
  return data;
}

export async function fetchShirtSizes(): Promise<ShirtSize[]> {
  try {
    const d = await getJson<{ sizes: ShirtSize[] }>('/api/v1/shirt-sizes');
    if (d.sizes?.length) return d.sizes;
  } catch {
    /* fallback abaixo */
  }
  const d = await getJson<{ sizes: ShirtSize[] }>('/shirt-sizes.json');
  return d.sizes;
}

export interface Produto {
  id: string;
  sku: string;
  nome: string;
  tipo: string;
  precoCentavos: number;
}
export async function fetchProdutos(): Promise<Produto[]> {
  const d = await getJson<{ products: Produto[] }>('/api/v1/products');
  return d.products;
}

export interface OpcaoParcela {
  parcelas: number;
  valorParcelaCentavos: number;
  valorTotalCentavos: number;
  jurosEfetivoMensalPercent: number;
  liquidoLojistaCentavos: number;
  descricao: string;
}
export interface Simulacao {
  valorAVistaCentavos: number;
  estrategia: string;
  opcoes: OpcaoParcela[];
}
export async function simular(valorAVistaCentavos: number): Promise<Simulacao> {
  return postJson<Simulacao>('/api/v1/checkout/simulate', { valorAVistaCentavos });
}

export interface CheckoutInput {
  customer: { nome: string; email: string; telefone: string; cpf?: string };
  items: { productId: string; qtd: number; customization?: unknown }[];
  metodo: 'PIX' | 'CREDIT_CARD';
  parcelas?: number;
  cardToken?: string;
}
export interface CheckoutResult {
  orderId: string;
  chargeId: string;
  metodo: 'PIX' | 'CREDIT_CARD';
  status: string;
  valorAVistaCentavos: number;
  valorBrutoCentavos: number;
  valorLiquidoCentavos: number;
  parcelas: number;
  pixQrCode?: string;
  pixCopiaECola?: string;
}
export async function criarCheckout(input: CheckoutInput): Promise<CheckoutResult> {
  return postJson<CheckoutResult>('/api/v1/checkout', input);
}

export function formatBRL(cents: number): string {
  return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
